import fetchService from 'common/actions/fetchService';
import updateEntities from 'common/actions/updateEntities';
import busGoShowBookingFormSchema from 'modules/bus/go-show/shared/schemas/busGoShowBookingFormSchema';
import { normalize } from 'normalizr';
import { getEntities } from 'common/redux/entities/selectors';
import busProviderId from 'modules/bus/shared/selectors/userConfig/busProviderId';
import TemporarySystemDisruptionException from 'common/exceptions/TemporarySystemDisruptionException';
import i18n from 'common/locale/i18n';
import UnavailableRouteException from 'common/exceptions/UnavailableRouteException';

export const FETCH_GO_SHOW_BOOKING_FORM_DETAILS =
  'BUS/FETCH_GO_SHOW_BOOKING_FORM_DETAILS';

export default function fetchBookingFormDetails(id) {
  return function thunk(dispatch, getState) {
    const entity = getEntities(getState()).busBookingInventory[id];
    const spec = {
      departureDate: entity.departureTime.specificDate.monthDayYear,
      skuId: entity.skuId,
      routeId: entity.routeId,
      providerId: busProviderId(getState()),
    };
    return dispatch(
      fetchService(({ pssService }) =>
        pssService.fetch(
          'POST',
          '/api/v2/busextranetagent/booking/goShowForm',
          spec
        )
      )
    )
      .catch(() => {
        throw new TemporarySystemDisruptionException(
          i18n.getText('error_temporary_disruption_message'),
          {
            title: i18n.getText('error_temporary_disruption_title'),
          }
        );
      })
      .then(({ result }) => {
        if (result.data.bookingRoutes.length === 0) {
          throw new UnavailableRouteException(result.data.message, {
            title: i18n.getText('error_unavailable_route_title'),
            hideCtaButton: true,
          });
        }
        const { entities, result: idResults } = normalize(
          result.data.bookingRoutes,
          [busGoShowBookingFormSchema]
        );
        dispatch(updateEntities(entities));
        dispatch({
          type: FETCH_GO_SHOW_BOOKING_FORM_DETAILS,
          payload: { ...result.data, bookingRoutes: idResults },
        });
      });
  };
}
